import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionState } from 'src/app/enums/action-state.enum';
import { NetworkRepo } from 'src/app/repositories/network-repo';
import { VnfDashboardRepo } from 'src/app/repositories/vnf-dashboard/repo/vnf-dashboard-repo';
import { ApplicationFeature } from 'src/swagger-gen/web-secured/models';
import { DataAfterCloseVnfDashboardModal } from './models/dataAfterCloseVnfDashboardModal';

@Component({
    selector: 'app-modal-vnf-dashboard',
    templateUrl: './modal-vnf-dashboard.component.html',
    styleUrls: ['./modal-vnf-dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalVnfDashboardComponent implements OnInit {

  FEATURE = ApplicationFeature;

  // downloadFile
  backendResponseDownloadedFile: any = null;
  backendResponseDownloadedFileVnfDashboard: any = null;
  // uploadFile
  backendResponseUploadedFile: any = null;
  backendResponseUploadedFileVnfDashboard: any = null;

  constructor(
    private vnfDashboardRepo: VnfDashboardRepo,
    @Inject(MAT_DIALOG_DATA) public data: DataAfterCloseVnfDashboardModal) {
  }

  ngOnInit(): void {
    this.data = new DataAfterCloseVnfDashboardModal();
  }


  // onUserWantsDownloadEvent(event: boolean): void {
  //   if (event) {
  //     this.downloadFile();
  //   }
  // }

  onUserWantsDownloadVnfDashboardEvent(event: boolean): void {}

  // onUserWantsUploadEvent(file: any): void {
  //   if (file) {
  //     this.uploadVnfDashboardFile(file);
  //   }
  // }

  // onUserWantsDownloadVnfDashboardEvent(event: boolean): void {
    // if (event) {
      // this.downloadVnfDashboardFile();
    // }
  // }

  onUserWantsUploadVnfDashboardEvent(file: any): void {
    if (file) {
      this.uploadVnfDashboardFile(file);
    }
  }



  // downloadFile(): void {
    // this.networkRepo.exportNetworkDefinition().toPromise()
    // .then((response) => {
      // this.backendResponseDownloadedFile = response;
    // })
    // .catch((err) => {
      // this.backendResponseDownloadedFile = err;
    // });
  // }

  // uploadFile(file: any): void {
  //   this.data.uploadFileState = ActionState.LOADING;
  //   this.networkRepo.importNetworkDefinition(file).toPromise()
  //   .then((response) => {
  //     this.backendResponseUploadedFile = response;
  //     this.data.uploadFileState = ActionState.SUCCESS;
  //   })
  //   .catch((err) => {
  //     this.backendResponseUploadedFile = err;
  //     this.data.uploadFileState = ActionState.FAILED;
  //   });
  // }



  // downloadStationsFile(): void {
    // this.vnfDashboardRepo.exportStationDefinition().toPromise()
    // .then((response) => {
      // this.backendResponseDownloadedFileStations = response;
    // })
    // .catch((err) => {
      // this.backendResponseDownloadedFileStations = err;
    // });
  // }

  uploadVnfDashboardFile(file: any): void {
    this.data.uploadFileState = ActionState.LOADING;
    this.vnfDashboardRepo.importVnfDashboardDefinition(file).toPromise()
    .then((response) => {
      this.backendResponseUploadedFileVnfDashboard = response;
      this.data.uploadFileState = ActionState.SUCCESS;
    })
    .catch((err) => {
      this.backendResponseUploadedFileVnfDashboard = err;
      this.data.uploadFileState = ActionState.FAILED;
    });
  }
}
